import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Products Service - safe for anon select (RLS enforced)
export const productsService = {
  async getAll() {
    const { data, error } = await supabase
      .from('products')
      .select('*')
      .eq('active', true)
      .order('display_order', { ascending: true });
    
    if (error) throw error;
    
    // Map Supabase fields to frontend format
    return data.map(product => ({
      productId: product.id,
      id: product.id,
      slug: product.slug,
      name: product.name,
      description: product.description,
      price: product.price_pc || 0,
      discount_price: product.discount_price,
      imageUrl: product.image_url,
      category: product.category,
      features: product.features || [],
      stock: product.stock,
      active: product.active,
      platforms: {
        android: {
          price: product.price_android || product.price_pc || 0
        },
        ios: {
          price: product.price_ios || product.price_pc || 0
        },
        pc: {
          price: product.price_pc || 0
        }
      }
    }));
  },

  async getById(slugOrId) {
    let query = supabase.from('products').select('*');
    
    if (slugOrId.includes('-') && slugOrId.length > 36) {
      query = query.eq('slug', slugOrId);
    } else if (slugOrId.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)) {
      query = query.eq('id', slugOrId);
    } else {
      query = query.eq('slug', slugOrId);
    }
    
    const { data, error } = await query.single();
    
    if (error) throw error;
    
    return {
      productId: data.id,
      id: data.id,
      slug: data.slug,
      name: data.name,
      description: data.description,
      price: data.price_pc || 0,
      discount_price: data.discount_price,
      imageUrl: data.image_url,
      category: data.category,
      features: data.features || [],
      stock: data.stock,
      active: data.active,
      platforms: {
        android: {
          price: data.price_android || data.price_pc || 0
        },
        ios: {
          price: data.price_ios || data.price_pc || 0
        },
        pc: {
          price: data.price_pc || 0
        }
      }
    };
  }
};

// Orders Service - Now routes through secure serverless API endpoints to block bot exploits
export const ordersService = {
  async create(orderData) {
    const response = await fetch('/api/create-order', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(orderData)
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.error || 'Failed to place order.');
    }
    return result;
  },

  async getByOrderNumber(orderNumber, email) {
    if (!orderNumber || !email) {
      throw new Error('Order number and email address are required.');
    }

    const params = new URLSearchParams({
      orderId: orderNumber,
      email: email
    });

    const response = await fetch(`/api/get-order?${params.toString()}`);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error || 'Failed to retrieve order.');
    }
    return result;
  }
};
